import sections from './sections';
import Home from './Home';

const index = {
  sections,

  Home,
};

export default index;